import * as React from "react";

const SearchBar: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 35 31" fill="currentColor">
            <path fill="#00205b" fillRule="evenodd" d="M0 0h35v31H0z" clipRule="evenodd" />
            <path
                fill="#ffcd00"
                d="m24.7 20.9-3.5-3.5c.8-1.2 1.2-2.7 1-4.2-.4-2.7-2.6-4.9-5.2-5.2-4-.5-7.3 2.9-6.8 6.8.3 2.7 2.5 4.9 5.2 5.2 1.6.2 3.1-.2 4.2-1l3.5 3.5c.5.5 1.2.5 1.7 0 .3-.4.3-1.2-.1-1.6zM12.3 14c0-2.1 1.7-3.8 3.8-3.8s3.7 1.7 3.7 3.8-1.7 3.8-3.7 3.8-3.8-1.8-3.8-3.8z"
            />
        </svg>
    );
};

export default React.memo(SearchBar);
